import { Component } from '@angular/core';

@Component({
    selector: 'app-date-picker-popover',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.scss']
})
export class DatePickerPopoverComponent {
}
